import { Table } from "@radix-ui/themes"

interface ImportPreviewTableProps {
  headers: string[]
  preview_data: (string | null)[][]
  file_count_lines: number | null
}

export default function ImportPreviewTable({ headers, preview_data }: ImportPreviewTableProps) {
  return (
    <div style={{ overflowX: "auto" }}>
      <Table.Root>
        <Table.Header>
          <Table.Row>
            {headers.map((header, index) => (
              <Table.ColumnHeaderCell key={index}>{header}</Table.ColumnHeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {preview_data[0]?.slice(1).map((_, rowIndex) => (
            <Table.Row key={rowIndex}>
              {preview_data.map((column, colIndex) => (
                <Table.Cell key={colIndex}>{column[rowIndex + 1] ?? ""}</Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </div>
  )
}
